import React from 'react'
import { Container, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';

/**
 * 処理中画面
 * サーバからのレスポンスを待つときに表示する
 */
export function Processing() {

    const [t] = useTranslation();

    return(
        <>
            <Container>
                <Typography
                    variant="h6"
                    sx={{
                        mt:2
                    }}
                >
                    {t("Processing.Processing")}
                </Typography>
            </Container>
        </>
    );
}